export const previewFormats = [
  'jpg',
  'jpeg',
  'png',
  'pdf',
  'JPG',
  'JPEG',
  'PNG',
  'PDF',
];
